angular
	.module 'App'
	.run ($transitions) ->
		$transitions.onBefore {to: 'login'}, =>
			hash = window.location.hash.substring 1

			if hash
				msalRedirectBridge.broadcastResponseToMainFrame()
